import { useState } from 'react'
import AdditionalDetails from './AdditionalDetails';
import Contacts from './Contacts';
import Keywords from './Keywords';
import Notes from './Notes';
import '../css/Misc.css';

const Misc = ({ keywords, color, setKeywords, notes, setNotes, description, setDescription, additionalDetails, setAdditionalDetails, currentUser, jobId}) => {
    const [activeTab, setActiveTab] = useState('keywords')
    const types = ['keywords', 'notes', 'contacts', 'additional details']
    return (
        <div>
        <div className='status-bar'>
            {types.map(type => (
                <label key={type} className='status-type'>
                    <input
                        type='radio'
                        name='activeTab'
                        value={type}
                        checked={type===activeTab}
                        onChange={()=>setActiveTab(type)}
                    />
                    <span>{type}</span>
                </label>
            ))}
            
        </div>
        {
                activeTab === 'keywords'? <Keywords keywords={keywords} setKeywords={setKeywords} description={description} setDescription={setDescription} currentUser={currentUser} jobId={jobId}/>:
                activeTab === 'notes'? <Notes notes={notes} setNotes={setNotes} currentUser={currentUser} jobId={jobId}/>:
                activeTab === 'contacts'? <Contacts currentUser={currentUser} jobId={jobId} color={color}/>:
                activeTab === 'additional details'? <AdditionalDetails additionalDetails={additionalDetails} setAdditionalDetails={setAdditionalDetails} currentUser={currentUser} jobId={jobId}/>:
                null
            }
        </div>
    )
};
export default Misc;

